import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';
import moment from 'moment';

const CalculateCampaignPrice = {
  name: 'calculateCampaignPrice',
  state: {
    data: {},
    loading: false,
    error: '',
  },
  reducers: {
    calculateRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
      };
    },

    calculateSucceeded(state, payload) {
      return {
        ...state,
        data: payload,
        loading: false,
        error: '',
      };
    },

    calculateFailed(state, payload) {
      return {
        ...state,
        error: payload,
        loading: false,
      };
    },
  },
  effects: (dispatch) => ({
    async fetchCampaignPrice({ startDate, endDate, displayIds }) {
      try {
        // Format the dates using moment
        const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
        const formattedEndDate = moment(endDate).format('YYYY-MM-DD');
        const org_id = JSON.parse(localStorage.getItem('userInfo')).org_id;
        // Construct the query params for the GET request
        const queryParams = `startDate=${formattedStartDate}&endDate=${formattedEndDate}&displayIds=[${displayIds}]&org_id=${org_id}`;
        const url = `savvy/campaigns/calculate-campaign-price?${queryParams}`;

        // Dispatch action to indicate the request has started
        this.calculateRequested();
        
        // Perform the GET request
        const response = await http.get(url);
        
        // Handle successful response
        this.calculateSucceeded(response.data);

        // Show success message using dispatch
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'success',
            message: 'Campaign price calculated successfully!',
            show: true,
          },
        });
      } catch (error) {
        // Handle failure
        this.calculateFailed(error.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(error.message),
            show: true,
          },
        });
      }
    },
  }),
};

export default CalculateCampaignPrice;
